import { useServices } from '@/components/ServiceContext.tsx';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage.tsx';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const AcxoimDoNotMailReport: React.FC = () => {
  const { boughtListService } = useServices();

  const report = reportDefinitions.find(
    rd => rd.id === 'report-bl-acxiom-do-not-mail'
  );

  return (
    report && (
      <GenericReportPage
        listType="boughtlist"
        listService={boughtListService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default AcxoimDoNotMailReport;
